import React from 'react';
import c from 'classnames';
import { BiEvent } from '@wix/da-bi/pkg/events';
import { attemptSocialLogin as attemptSocialLoginAction } from '../redux/actions';
import { SocialLoginProvider } from '../types';
import SocialButtonBase from '../SocialButtonBase';
import SocialButtonIconViewBase from '../SocialButtonIconViewBase';
import useAppleSignIn from '../hooks/useAppleSignIn';

import s from './SocialButtonApple.scss';

export interface Props {
  clientId: string;
  sessionId?: string;
  biData?: BiEvent;
  className?: string;
  view?: 'standard' | 'icon';
  redirectToJoin?: boolean;
  redirectToSisu?: boolean;
  attemptSocialLogin: typeof attemptSocialLoginAction;
}

const SocialButtonApple: React.FC<React.PropsWithChildren<Props>> = ({
  clientId,
  sessionId,
  biData,
  className,
  view = 'standard',
  redirectToJoin = false,
  redirectToSisu,
  attemptSocialLogin,
  children,
}) => {
  const { signIn } = useAppleSignIn(clientId, sessionId, response => {
    attemptSocialLogin({
      provider: SocialLoginProvider.Apple,
      token: response.authorization.id_token,
      redirectToJoin,
      redirectToSisu,
    });
  });

  const onClick = (e: React.MouseEvent) => {
    e.preventDefault();
    signIn();
  };

  if (view === 'icon') {
    return (
      <SocialButtonIconViewBase
        className={c(s['root'], s['icon'], className)}
        biData={biData}
        onClick={onClick}
      />
    );
  }

  return (
    <SocialButtonBase
      className={c(s['root'], className)}
      biData={biData}
      onClick={onClick}
      aria-label="Apple"
    >
      {children}
    </SocialButtonBase>
  );
};
SocialButtonApple.displayName = 'SocialButtonApple';

export default SocialButtonApple;
